import { render, staticRenderFns } from "./TableBaskets.vue?vue&type=template&id=987796c6&scoped=true"
import script from "./TableBaskets.vue?vue&type=script&lang=js"
export * from "./TableBaskets.vue?vue&type=script&lang=js"
import style0 from "./TableBaskets.vue?vue&type=style&index=0&id=987796c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987796c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataFooter,VDataTable,VTextField})
